/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from "../runtime";
import { ActivityFromJSONTyped, ActivityToJSON, } from "./Activity";
import { ActivityTypeFromJSON, ActivityTypeToJSON, } from "./ActivityType";
import { MuscleShareFromJSON, MuscleShareToJSON, } from "./MuscleShare";
/**
 * Check if a given object implements the ActivityJob interface.
 */
export function instanceOfActivityJob(value) {
    let isInstance = true;
    isInstance = isInstance && "$type" in value;
    return isInstance;
}
export function ActivityJobFromJSON(json) {
    return ActivityJobFromJSONTyped(json, false);
}
export function ActivityJobFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        ...ActivityFromJSONTyped(json, ignoreDiscriminator),
        $type: ActivityTypeFromJSON(json.$type),
        muscleShares: !exists(json, "muscleShares")
            ? undefined
            : json.muscleShares === null
                ? null
                : json.muscleShares.map(MuscleShareFromJSON),
    };
}
export function ActivityJobToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ActivityToJSON(value, true),
        $type: ActivityTypeToJSON(value.$type),
        muscleShares: value.muscleShares === undefined
            ? undefined
            : value.muscleShares === null
                ? null
                : value.muscleShares.map(MuscleShareToJSON),
    };
}
